var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "draggable-1" } }, [
    _vm._v("\n    " + _vm._s(_vm.ShowHidePopUp) + "\n    "),
    _vm.openclosepopup
      ? _c(
          "div",
          [
            _c("transition", { attrs: { name: "modal" } }, [
              _c("div", {}, [
                _c("div", { staticClass: "modal-wrapper" }, [
                  _c("div", { staticClass: "modal-container modal-width500" }, [
                    _c(
                      "div",
                      {
                        staticClass: "modal-body",
                        staticStyle: { cursor: "move" },
                        attrs: { id: "mydiv" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "prompt-style-sml",
                            attrs: { id: "mydivheader" },
                          },
                          [
                            _vm._v(
                              "\n                                Click here to move\n                            "
                            ),
                          ]
                        ),
                        _c("p", { staticClass: "prompt-style-sml" }),
                        _c("div", { attrs: { id: "vdoiframecontainer" } }, [
                          _c("div", { attrs: { id: "videos" } }, [
                            _c("div", { attrs: { id: "subscriber" } }),
                            _c("div", { attrs: { id: "publisher" } }),
                            _c("div", { staticClass: "btn-info-hold" }, [
                              _c("button", {
                                staticStyle: {
                                  padding: "8px",
                                  cursor: "pointer",
                                },
                                attrs: { id: "disconnectpublisher" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.disconnectCall.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                        _c("p"),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }